export default __webpack_public_path__ + "media/images/theme_apple/home_icon-30eff16fd7094b9f57dc85f32068ec0b.png";